module.exports = __webpack_public_path__ + "img/delete-file.0f3a5148.png";